import React from 'react';
import css from './ProfilePage.module.css';
import { FormattedMessage } from 'react-intl';
import Icons from '../../components/Icons/Icons';
import { H4 } from '../../components';
import { getLabelFromKey } from '../../util/genericHelpers';
import { designScopeOptions } from '../../util/general';

const DesignScopeSection = ({ publicData = {} }) => {
  const { designScope } = publicData;

  if (!designScope) return null;

  return (
    <div className={css.infoBlock}>
      <h2>
        <FormattedMessage id="ProfilePage.designScopeOption" />
      </h2>

      <H4 as="h4">
        <FormattedMessage id="ProfilePage.designScope.heading" />
      </H4>

      <div className={css.serviceList}>
        <div className={css.service}>
          <Icons name="check" /> {getLabelFromKey(designScope, designScopeOptions)}
        </div>
      </div>
    </div>
  );
};

export default DesignScopeSection;
